/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Achievement_Early_Bird_HintInputs */

const en_us2_achievement_early_bird_hint = /** @type {(inputs: Achievement_Early_Bird_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 workouts before 7 am`)
};

const pt_br2_achievement_early_bird_hint = /** @type {(inputs: Achievement_Early_Bird_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 treinos antes das 7h`)
};

const es_419_achievement_early_bird_hint = /** @type {(inputs: Achievement_Early_Bird_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 entrenamientos antes de las 7 h`)
};

const pt_pt2_achievement_early_bird_hint = /** @type {(inputs: Achievement_Early_Bird_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 treinos antes das 7h`)
};

const fr_fr2_achievement_early_bird_hint = /** @type {(inputs: Achievement_Early_Bird_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 séances avant 7 h`)
};

const de_de2_achievement_early_bird_hint = /** @type {(inputs: Achievement_Early_Bird_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 Trainings vor 7 Uhr`)
};

const it_it2_achievement_early_bird_hint = /** @type {(inputs: Achievement_Early_Bird_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 allenamenti prima delle 7`)
};

/**
* | output |
* | --- |
* | "3 workouts before 7 am" |
*
* @param {Achievement_Early_Bird_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const achievement_early_bird_hint = /** @type {((inputs?: Achievement_Early_Bird_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Achievement_Early_Bird_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_achievement_early_bird_hint(inputs)
	if (locale === "es-419") return es_419_achievement_early_bird_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_achievement_early_bird_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_achievement_early_bird_hint(inputs)
	if (locale === "de-DE") return de_de2_achievement_early_bird_hint(inputs)
	if (locale === "it-IT") return it_it2_achievement_early_bird_hint(inputs)
	return en_us2_achievement_early_bird_hint(inputs)
});
export { achievement_early_bird_hint as "achievement.early_bird_hint" }